let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iZvLM")).then(() => parcelRequire('3LR6X'));